<!--
 * @Desc: 
 * @Author: may.li
 * @Date: 2023-05-11 14:11:36
 * @LastEditors: wanglidong 王立冬
 * @LastEditTime: 2023-12-26 08:02:36
-->
<template>
    <div class="add-danwei">
        <el-form
            ref="ruleForm"
            :model="viewData"
            :rules="rules"
            label-width="140px"
        >
            <el-form-item label="小区" prop="community_id">
                <el-select
                        v-model="viewData.community_id"
                        clearable
                        filterable
                        placeholder="请选择小区"
                >
                <el-option v-for="item in optionList"
                            :key="item.id"
                            :label="item.commName"
                            :value="item.id" />
                </el-select>
            </el-form-item>
            <el-form-item label="标题" prop="title">
                <el-input v-model="viewData.title" />
            </el-form-item>
            <el-form-item label="封面图">
                <image-upload ref="imageUpload"
                          v-if="showUpload"
                          :tipInfo="`上传图片格式为'jpg','jpeg','png','gif'，大小不超过2M，建议尺寸600*600,请自己处理好宽高比例`"
                          :image-list="imageDefaultList"
                          :autoCropWidth="600"
                          :autoCropHeight="600"
                          :maxNumber="1"
                          @updateImg="onUpdateImg($event)"></image-upload>
            </el-form-item>
            <el-form-item label="内容"
                            prop="desc">
                <!-- <tinymce ref="tinymce"
                        v-if="showUpload"
                        v-model="viewData.desc"
                        :height="300" /> -->
                    <vue-ueditor-wrap v-model="viewData.desc" :config="ueconfig"></vue-ueditor-wrap>
                    <!-- <Ueditor :content="viewData.desc"></Ueditor> -->
            </el-form-item>
            <el-form-item label="活动时间" prop="begin_at">
                <el-date-picker
                    v-model="begin"
                    type="datetimerange"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    :default-time="['00:00:00', '23:59:59']">
                </el-date-picker>
          </el-form-item>
          <el-form-item label="报名时间" prop="bm_begin_at">
            <el-date-picker
                    v-model="bm"
                    type="datetimerange"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    :default-time="['00:00:00', '23:59:59']">
                </el-date-picker>
          </el-form-item>
          <el-form-item label="联系人" prop="contact_name">
                <el-input v-model="viewData.contact_name" />
            </el-form-item>
            <el-form-item label="联系方式" prop="contact_phone">
                <el-input v-model="viewData.contact_phone" />
            </el-form-item>

          <el-form-item label="活动地点" prop="address">
                <el-input v-model="viewData.address" />
            </el-form-item>
            <!-- <el-form-item label="排序">
                <el-input-number
                    size="mini"
                    style="width: 100px"
                    v-model="viewData.sort"
                    controls-position="right"
                    :min="0"
                ></el-input-number>
            </el-form-item> -->
            <!-- <el-form-item label="状态">
                <el-switch
                    v-model="viewData.status"
                    class="drawer-switch"
                    active-color="#13ce66"
                    inactive-color="#ff4949"
                    :active-value="1"
                    :inactive-value="0"
                />
            </el-form-item> -->
        </el-form>
        <div class="fix-fotter">
            <el-button style="min-width: 117px;background: #1067E0;font-size: 16px;border-color: #1067E0;" size="mini" type="primary" @click="tijiao('ruleForm')">提交</el-button>
        </div>
    </div>
</template>

<script>
import ImageUpload from "@/components/Upload/image";
import fetch from "@/api/tianzheng/activity";
import Qu from "@/api/tianzheng/Qu";
import Tinymce from '@/components/Tinymce'
import VueUeditorWrap from 'vue-ueditor-wrap'
import Pagination from "@/components/Pagination"; // Secondary package based on el-pagination
export default {
    data() {
        return {
            thumbList: [],
            imageDefaultList: "",
            showUpload:false,
            optionList: [],
            begin:'',
            bm:'',
            ueconfig: {
                
                initialFrameHeight: 300,
                // 初始容器宽度
                initialFrameWidth: '100%',
                // 关键配置：提高弹窗层级
                zIndex: 9000,  // el-dialog默认z-index是2000+，设置更高的值
                catchRemoteImageEnable: true,
                serverUrl: 'https://xcx.tzwyfw.com/ueditor/controller.php',
                withCredentials: true,
                
            },
            viewData: {
                id:'',
                community_id: "",
                title: "",
                thumb: "",
                desc: "",
                bm_begin_at: "",
                bm_end_at: "",
                begin_at: '',
                end_at: '',
                contact_name: '',
                contact_phone: '',
                address: '',
            },
            rules: {
                contact_name: [
                    {
                        required: true,
                        message: "请输入内容",
                        trigger: "blur",
                    },
                ],
                contact_phone: [
                    {
                        required: true,
                        message: "请输入内容",
                        trigger: "blur",
                    },
                ],
                address: [
                    {
                        required: true,
                        message: "请输入内容",
                        trigger: "blur",
                    },
                ],
                title: [
                    {
                        required: true,
                        message: "请输入标题",
                        trigger: "blur",
                    },
                ],
                community_id: [
                    {
                        required: true,
                        message: "请选择小区",
                        trigger: "change",
                    },
                ],
                desc: [
                    {
                        required: true,
                        message: "请输入内容",
                        trigger: "blur",
                    },
                ],
                bm_begin_at: [
                    {
                        required: true,
                        message: "请选择时间",
                        trigger: "blur",
                    },
                ],
                bm_end_at: [
                    {
                        required: true,
                        message: "请选择时间",
                        trigger: "blur",
                    },
                ],
                begin_at: [
                    {
                        required: true,
                        message: "请选择时间",
                        trigger: "blur",
                    },
                ],
                end_at: [
                    {
                        required: true,
                        message: "请选择时间",
                        trigger: "blur",
                    },
                ],
            },
        };
    },
    components: {
        Pagination,
        Tinymce,
        ImageUpload,
        VueUeditorWrap
    },
    created() {
        this.getSelectCity()
    },
    methods: {
        onUpdateImg (val) {
            console.log('update:',val)
            let thumbList = [];
            val.forEach((ele, idx) => {
                thumbList.push(ele.path);
            });
            this.thumbList = thumbList;
        },
        updateContent(val) {
            console.log('updateContent:',val)
        },
        // 获取下拉列表
        getSelectCity () {
            Qu.select({}).then(res => {
                if (res.code == 200) {
                this.optionList = res.result;
                }
            })
        },
        /**
         * @name: 初始化列表
         * @param {*} obj
         * @return {*}
         * @desc:
         */
        initFun(obj) {
            let that = this
            this.begin = ''
            this.bm = ''
            this.resetForm()
            this.viewData = {
                id:'',
                community_id: "",
                title: "",
                thumb: "",
                desc: "",
                bm_begin_at: "",
                bm_end_at: "",
                begin_at: '',
                end_at: '',
                contact_name: '',
                contact_phone: '',
                address: '',
                status: 1,
                sort: 0,
            }
            this.showUpload = true
            if (obj.id) {
                // 编辑
                this.viewData.id = obj.id;
                fetch.detail({ id: obj.id }).then((res) => {
                    console.log(res)
                    if (res.code == 200) {
                        that.viewData = res.result
                        that.viewData.id = res.result.id;
                        setTimeout(function(){
                            if (that.viewData.desc) {
                                that.$refs["tinymce"].setContent(that.viewData.desc);
                            } else {
                                that.$refs["tinymce"].setContent('');
                            }
                            if (that.viewData.thumb) {
                                let imgList = [];
                                let obj = {
                                    name: that.viewData.thumb,
                                    path: that.viewData.thumb,
                                    url: that.$publicData.imgUrl + that.viewData.thumb,
                                }
                                imgList.push(obj);
                                // 回显图
                                that.imageDefaultList = JSON.stringify(imgList);
                            };
                            that.begin=[that.viewData.begin_at,that.viewData.end_at]
                            that.bm=[that.viewData.bm_begin_at,that.viewData.bm_end_at]
                        },500)
                    }
                });
            } else {
                // 新增
            }
        },
        /**
         * @name: 提交
         * @param {*} formName
         * @return {*}
         * @desc: 
         */		
         tijiao(formName) {
            if (this.begin && this.begin.length>0) {
                this.viewData.begin_at = this.begin[0]
                this.viewData.end_at = this.begin[1]
            }
            if (this.bm && this.bm.length>0) {
                this.viewData.bm_begin_at = this.bm[0]
                this.viewData.bm_end_at = this.bm[1]
            }
            let that = this
            if(this.thumbList.length<1){
                this.$message.warning("请上传封面图")
                return
            } else {
                this.viewData.thumb = this.thumbList[0];
            }
            console.log(this.viewData)
            this.$refs[formName].validate(valid => {
                if (valid) {
					if(this.viewData.id){
						// 编辑
						fetch.edit(this.viewData).then(res=>{
							if(res.code == 200){
								that.$message.success(res.message);
								that.$emit('onUpdateDrawer', 1)
							}else{
								that.$message.error(res.message);
								that.$emit('onUpdateDrawer', -1)
							}
						})
					}else{
						// 新增
						fetch.create(this.viewData).then(res=>{
							if(res.code == 200){
								that.$message.success(res.message);
								that.$emit('onUpdateDrawer', 1)
							}else{
								that.$message.error(res.message);
								that.$emit('onUpdateDrawer', -1)
							}
						}) 
					}
                      
                } else {
                    this.$message.warning(this.$t('form.verifyMsg'))
                }
            })
        },
        /**
         * @name: 清空form
         * @return {*}
         * @desc:
         */
        resetForm() {
            if (this.$refs["tinymce"]) {
                this.$refs["tinymce"].setContent('');
            }
            this.thumbList = [];
            this.imageDefaultList = "";
            if (this.$refs.imageUpload) {
                this.$refs.imageUpload.clearFileList();
            }
            this.$refs["ruleForm"].resetFields();
            this.showUpload = false;
        },
    },
};
</script>

<style lang="scss" scoped>
</style>
